<template>
    <Page route-path="/blockchain.html">
      <div class="body">
        <div class="first-image">
          <div class="banner-container">
            <img v-if="isNormal" class="backgroud-image" src="@/assets/BlockChain/block_chain_banner.png" />
            <img v-else class="backgroud-image" src="@/assets/mobile/blockchain/blockchain-banner.svg" />
          </div>
          <div class="head-content">
            <div class="image-title">千尺区块链底层平台</div>
            <div class="text">企业级、高性能、通用区块链系统</div>
            <!-- <el-button style="width: 140px;height: 48px;font-size: 18px;">免费试用</el-button> -->
          </div>
        </div>
        <div class="introduce-container">
          <div class="introduce">
            <span class="intro-header"> 千尺链 </span>
            <span class="intro-content">
              链聚信息打造了完全自主知识产权、高性能可扩展、产品化成熟的商用级区块链底层平台—千尺链。应用开发友好的智能合约、安全高效的共识算法、可靠的隐私保护、并行快速的多链，以及可扩展的跨链技术等创新；同时，经过大量实际业务积累，千尺链实现了产品化重要突破：应用可快速构建、可视化运维、技术合规及资金账户体系等，形成完整的产品服务能力。
            </span>
          </div>
        </div>
        <div class="lowcode-advantage">
          <!-- <div class="introduce">
            <div class="introduce-text">
              链聚信息打造了完全自主知识产权、高性能可扩展、产品化成熟的商用级区块链底层平台—千尺链。应用开发友好的智能合约、安全高效的共识算法、可靠的隐私保护、并行快速的多链，以及可扩展的跨链技术等创新；同时，经过大量实际业务积累，千尺链实现了产品化重要突破：应用可快速构建、可视化运维、技术合规及资金账户体系等，形成完整的产品服务能力。
            </div>
          </div> -->
          <div class="title">平台优势</div>
          <div class="content">
            <div class="content-box">
              <img src="@/assets/BlockChain/blockchain_3.png" alt="" style="width: 100px; height: 100px" />
              <p class="content-box-title">简洁至上</p>
              <p class="content-box-text">提供面向 Java 开发者友好的开发方式，渐进式学习，约定优于配置， 轻量部署，快速上手</p>
            </div>
            <div class="content-box">
              <img src="@/assets/BlockChain/blockchain_4.png" alt="" style="width: 100px; height: 100px" />
              <p class="content-box-title">可靠灵活</p>
              <p class="content-box-text">
                原生支持国家密码标准算法，采用拜占庭容错（BFT）共识协议，提供通用的账本数据结构和开发工具，保证区块链服务安全可靠、适用和可扩展
              </p>
            </div>
            <div class="content-box">
              <img src="@/assets/BlockChain/blockchain_5.png" alt="" style="width: 100px; height: 100px" />
              <p class="content-box-title">高性能</p>
              <p class="content-box-text">无需专用硬件，采用通用服务器 即可支撑企业级的高吞吐量事务处理和 海量的数据上链存储</p>
            </div>
          </div>
        </div>
    
        <div class="technical-advantages">
          <div class="title" style="margin: 0">我们的技术优势</div>
          <div class="technical-advantages-content">
            <div class="technical-advantages-content-box">
              <div class="technical-advantages-content-box-image">
                <img src="@/assets/BlockChain/blockchain_7.png" alt="" style="width: 36px; height: 36px" />
              </div>
              <div class="technical-advantages-content-box-text">
                <div>单链高性能</div>
                <div>2万TPS，10亿级账户数量，1000亿级交易记录</div>
              </div>
            </div>
            <div class="technical-advantages-content-box">
              <div class="technical-advantages-content-box-image">
                <img src="@/assets/BlockChain/blockchain_8.png" alt="" style="width: 36px; height: 36px" />
              </div>
              <div class="technical-advantages-content-box-text">
                <div>多层共识网络</div>
                <div>多账本并行处理，跨链合约校验执行，多链协同TPS可达百万级</div>
              </div>
            </div>
            <div class="technical-advantages-content-box">
              <div class="technical-advantages-content-box-image">
                <img src="@/assets/BlockChain/blockchain_9.png" alt="" style="width: 36px; height: 36px" />
              </div>
              <div class="technical-advantages-content-box-text">
                <div>联合权限控制</div>
                <div>多方联合授权，数据多级监管，分布式商业共治</div>
              </div>
            </div>
            <div class="technical-advantages-content-box">
              <div class="technical-advantages-content-box-image">
                <img src="@/assets/BlockChain/blockchain_10.png" alt="" style="width: 36px; height: 36px" />
              </div>
              <div class="technical-advantages-content-box-text">
                <div>标准化账本数据</div>
                <div>业务场景通用，结构化非机构化数据融合，数据可穿透检测分析</div>
              </div>
            </div>
            <div class="technical-advantages-content-box">
              <div class="technical-advantages-content-box-image">
                <img src="@/assets/BlockChain/blockchain_11.png" alt="" style="width: 36px; height: 36px" />
              </div>
              <div class="technical-advantages-content-box-text">
                <div>大规模节点共识</div>
                <div>大规模节点许可接入，弱网络环境高效共识，支持科监管公链场景</div>
              </div>
            </div>
            <div class="technical-advantages-content-box">
              <div class="technical-advantages-content-box-image">
                <img src="@/assets/BlockChain/blockchain_12.png" alt="" style="width: 36px; height: 36px" />
              </div>
              <div class="technical-advantages-content-box-text">
                <div>强安全隐私</div>
                <div>可监管匿名签名，穿透签名防攻击，密钥安全多方托管</div>
              </div>
            </div>
          </div>
        </div>
    
        <div class="product-value">
          <div class="title" style="margin: 0">产品价值</div>
          <div class="product-value-introduce-list">
            <div class="product-value-introduce-list-item" v-for="(item, index) of productValue" :key="index">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-text" v-for="(i, k) of item.text" :key="k">{{ i }}</div>
            </div>
          </div>
        </div>
    
        <div class="application-scenarios">
          <div class="title">应用场景</div>
          <div class="application-scenarios-tabs">
            <template v-if="isMobile">
              <div class="scenarios-devider"></div>
              <div class="scenario-pane" v-for="(item, index) of applicationScenarios" :key="index">
                <div class="pane-left">
                  <div class="backImage"></div>
                  <img :src="item.img" alt="" />
                </div>
                <div class="pane-right">
                  <div class="pane-right-title">
                    {{ item.title }}
                  </div>
                  <div class="pane-right-text">
                    {{ item.text }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) of applicationScenarios" :key="index" :label="item.title" :name="index">
                  <div class="scenario-pane">
                    <div class="pane-left">
                      <div class="backImage"></div>
                      <img :src="item.img" alt="" />
                    </div>
                    <div class="pane-right">
                      <div class="pane-right-title">
                        {{ item.title }}
                      </div>
                      <div class="pane-right-text">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </template>
          </div>
        </div>
      </div>
    </Page>
</template>
<script>

import { ResponsiveBase } from "../../layout/reponsive-base";

export default {
  name: "BlockChain",
  mixins: [ResponsiveBase],
  data() {
    return {
      activeName: 0,
      productValue: [
        {
          title: "法律效力、合规性",
          text: ["·支持电子合同及司法存证", "·支持国密算法SM2/SM3/SM4", "·区块链用户利用CA实名认证", "·区块链节点利用CA接入网络"],
        },
        {
          title: "易用性",
          text: [
            "·API支持短链接HTTP及长链接WebSocket协议",
            "·SDK支持Java/NodeJs/Python/PHP等开发语言",
            "·完善详尽的开发文档",
            "·智能合约支持JS/C/C++主流开发语言",
            "·集开发、测试部署于一体的智能合约IDE",
          ],
        },
        {
          title: "可视化运维",
          text: [
            "·提供对区块链全方位的可视化监控平台",
            "·提供多维度统计分析的区块链浏览器",
            "·节点支持本地、云端部署 ",
            "·多平台支持：Linux/Windows/MacOS/Android",
          ],
        },
        {
          title: "可视化运维",
          text: ["·链上账户与银行账户一体化", "·智能合约实现资金自动清算", "·清算过程依赖于链上签名， 不依赖于管理员"],
        },
      ],
      applicationScenarios: [
        {
          title: "供应链追溯",
          img: require("@/assets/BlockChain/application.png"),
          text: "企业可以在其供应链链条中与制造商、供应商、分销商等各种角色共享信息和数据，增加透明度区块链技术具有透明性和不可变性的特点，有利于消除供应链中的欺诈行为，维护系统的完整性。",
        },
        {
          title: "金融支付",
          img: require("@/assets/BlockChain/application2.png"),
          text: "区块链技术用于跨境支付业务，用以解决传统金融业务环节复杂、耗时长、费用高的难题；利用区块链的分布式账本、点对点传输、共识机制等技术，改善金融机构银行成本结构，提升支付处理效率，降低支付费用，实现交易信息、过程的实时追踪。",
        },
        {
          title: "医疗健康",
          img: require("@/assets/BlockChain/application3.png"),
          text: "建立以患者为中心的医疗保健体系和个性化的患者服务，将病人在不同医院的医生诊断信息、手术信息、用药记录和电子穿戴设备采集的生命体征数据等，完整记录，建立以患者为中心的医疗电子档案，共享关键医疗信息，提升医疗服务的精准性缓和诊疗效率，减少因信息不完整造成的医疗事故发生率，优化患者就诊体验。",
        },
        {
          title: "爱心公益",
          img: require("@/assets/BlockChain/application4.png"),
          text: "公益组织、支付机构、审计机构作为区块链中的节点，结成公益联盟，打破传统公益中心化运作，便于接受社会及大众的监督，区块链的智能合约用于保障每笔善款或物资都真实抵达，不会被任意挪用，其不可篡改的特性，让公益活动中的各种信息更加客观、透明、可信、助力社会公益的快速健康发展。",
        },
        {
          title: "绿色能源",
          img: require("@/assets/BlockChain/application5.png"),
          text: "能源互联网与区块链、物联网技术相结合，可减少能源的不均衡和低效率，并赋予消费者直接从其他消费者手中购买和销售能源的权利，通过模型算法，智能电力设备可以在最优时间自主买卖能源，实时优化能源系统设置，对耗能设备的性能进行监控和分析。",
        },
        {
          title: "文化娱乐",
          img: require("@/assets/BlockChain/application6.png"),
          text: "区块链技术让娱乐行业中产品的生成和传播过程变得真实透明，打破传统渠道中的多层中间人模式，提高产品原创人的收益，此外，粉丝通过众筹模式，可直接参与到偶像的产品创作、生产、传播和消费过程。",
        },
      ],
    };
  },
  created() {},
  inject: ["pageIndicator"],
  computed: {},

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="less" scoped>
span {
  font-size: 16px;
  color: #040420;
  font-weight: 400;
  line-height: 30px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
}

.body {
  padding-top: 65px;
}

.first-image {
  width: 100%;
  height: 428px;

  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .banner-container {
    position: absolute;
    top: 64px;
    width: 100%;
    height: 428px;

    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }

  .backgroud-image {
    height: 100%;
    width: 100%;
    min-width: 1280px;
    object-fit: cover;
  }

  .head-content {
    width: 100%;
    max-width: 1280px;
    z-index: 1000;
    margin: 0px 20px;
  }

  .image-title {
    font-size: 58px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 58px;
    @media screen and (max-width: 850px) {
    font-size: 30px;
  }
  }

  .text {
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    line-height: 30px;
    margin-top: 40px;
    margin-bottom: 50px;
    @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
  }
}

.lowcode-advantage {
  position: relative;
  padding-top: 82px;
  padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 36px;
  font-weight: 500;
  color: #040420;
  margin-top: 100px;
  text-align: center;
  -webkit-text-stroke: thin;
  @media screen and (max-width: 850px) {
    font-size: 24px;
  }
}

.content {
  max-width: 1280px;
  width: 100%;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 28px;
  column-gap: 28px;

  margin-top: 60px;
  padding: 0 30px;

  @media screen and (max-width: 1100px) {
    justify-content: center;
  }

  .content-box {
    width: 300px;
    text-align: center;
  }

  .content-box-title {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    margin: 36px 0px 24px;
    @media screen and (max-width: 850px) {
    font-size: 18px;
  }
  }

  .content-box-text {
    width: 290px;

    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
  }
}

.introduce-container {
  width: 100%;
  height: 166px;
  padding: 0;
  position: relative;
}

.introduce {
  max-width: 1280px;
  min-height: 190px;
  background-image: url(../../assets/BlockChain/blockchain_2.png);
  background-size: 100% 100%;
  background-color: #ffffff;
  padding: 50px 184px;
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: -32px;
  z-index: 1000;
  border: 4px solid #ffffff;
  box-shadow: 0px 0px 8px 1px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  column-gap: 90px;
  row-gap: 40px;

  @media screen and(max-width:850px) {
    padding: 50px;
  }

  .intro-header {
    font-size: 38px;
    font-weight: 500;
    width: 120px;
    @media screen and (max-width: 850px) {
    font-size: 24px;
    text-align: center;
  }
  }

  .intro-content {
    max-width: 680px;
    display: inherit;
    min-width: 340px;
    @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
  }
}

.technical-advantages {
  min-height: 696px;
  padding: 100px 30px 60px 30px;
  background: url(../../assets/BlockChain/blockchain_6.png) no-repeat center center;
  background-size: 100% 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.technical-advantages-content {
  width: 100%;
  max-width: 1280px;
  margin-top: 60px;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  column-gap: 8px;
  row-gap: 28px;

  @media screen and (max-width: 1280px) {
    column-gap: 28px;
    justify-content: center;
  }

  .technical-advantages-content-box-image {
    padding-top: 4px;
  }

  .technical-advantages-content-box {
    height: 196px;
    width: 400px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
    padding: 48px 36px;
    display: flex;

    @media screen and (max-width: 1280px) {
      width: 45%;
    }

    @media screen and (max-width: 850px) {
      width: 100%;
      max-width: 700px;
      height: auto;
      min-height: 60px;
      padding: 24px 32px;
    }

    .technical-advantages-content-box-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 24px;
    }

    .technical-advantages-content-box-text div:first-child {
      //   height: 24px;
      font-size: 24px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;
      line-height: 40px;
      @media screen and (max-width: 850px) {
    font-size: 18px;
  }
    }

    .technical-advantages-content-box-text div:last-child {
      //   height: 46px;
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      line-height: 30px;
      @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
    }
  }

  .technical-advantages-content-box:hover {
    box-shadow: 0px 0px 15px 1px rgba(0, 0, 0, 0.2);
  }
}

.product-value {
  background: #ffffff;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  // <div class="product-value-introduce-list">
  //         <div class="introduce-list-text">
  //             <div class="introduce-list-text-title">法律效力、合规性</div>
  //             <div class="introduce-list-text-content">
  //                 <div class="introduce-list-text-content-item">支持电子合同及私法认证</div>
  //                 <div class="introduce-list-text-content-item">支持国密算法SM2/SM3/SM4</div>
  //                 <div class="introduce-list-text-content-item">区块链用户利用CA实名认证</div>
  //                 <div class="introduce-list-text-content-item">区块链节点利用CA接入网络</div>
  //             </div>
  //         </div>
  //         <div class="introduce-list-image">
  //             <img src="@/assets/BlockChain/blockchain_4.png" alt="" style="width: 480px;height: 220px;" />
  //         </div>
  //     </div>
  .product-value-introduce-list {
    width: 100%;
    max-width: 1280px;
    margin-top: 60px;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    column-gap: 8px;
    row-gap: 28px;

    @media screen and (max-width: 1280px) {
      column-gap: 28px;
      justify-content: center;
    }

    .product-value-introduce-list-item {
      width: 299px;
      height: 426px;
      background: #f0f2f9;
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      padding: 48px 30px;

      @media screen and (max-width: 1280px) {
        width: 45%;
        height: auto;
        min-height: 240px;
      }

      @media screen and (max-width: 850px) {
        width: 100%;
        max-width: 700px;
        height: auto;
        min-height: 60px;
        padding: 24px 32px;
      }

      .item-title {
        font-size: 24px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #040420;
        border-left: 6px solid #2e64f3;
        padding-left: 12px;
        margin-bottom: 25px;
        @media screen and (max-width: 850px) {
    font-size: 18px;
  }
      }

      .item-text {
        font-size: 18px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 32px;
        @media screen and (max-width: 850px) {
    font-size: 14px;
    line-height: 24px;
  }
      }
    }

    .product-value-introduce-list-item:hover {
      background: #ffffff;
      box-shadow: 5px 5px 15px 1px rgba(96, 129, 217, 0.15);
    }
  }
}

.application-scenarios-tabs {
  padding-top: 52px;

  .scenario-devider {
    width: 1920px;
    height: 2px;
    background: #efefef;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }
  .scenario-pane {
    display: flex;

    @media screen and (max-width: 850px) {
      flex-direction: column-reverse;
      margin-bottom: 30px;
    }
  }

  .pane-left {
    position: relative;
    width: 50%;

    @media screen and (max-width: 850px) {
      width: 100%;
      padding: 0;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .backImage {
    width: 100%;
    height: 100%;
    background: linear-gradient(270deg, rgba(240, 242, 249, 0) 0%, #f0f2f9 100%);
    position: absolute;
    z-index: 100;
  }

  .pane-right {
    width: 50%;
    padding: 80px 115px;
    display: flex;
    background: #F0F2F9;
    flex-direction: column;

    @media screen and(max-width:1000px) {
      padding: 60px 60px;
    }

    @media screen and(max-width:850px) {
      width: 100%;
      padding: 30px 30px;
    }
  }

  .pane-right-title {
    font-size: 28px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    margin-bottom: 40px;

    @media screen and (max-width:850px) {
        font-size: 18px;
    }
  }

  .pane-right-text {
    max-width: 527px;
    // height: 76px;
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;

    @media screen and(max-width:850px) {
      width: 100%;
      max-width: fit-content;
      font-size: 14px;
      line-height: 24px;
    }
  }
}

:deep(.el-tabs) {
  display: flex;
  --el-tabs-header-height: 40px;
  flex-direction: column;
  align-items: center;
}

:deep(.el-tabs__header) {
  margin: 0px;
}
:deep(.el-tabs__content){
  width: 100%;
}
:deep(.el-tabs .el-tabs__header) {
  width: 100%;
  max-width: 1280px;
  padding: 0px 30px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

:deep(.el-tabs .el-tabs__nav) {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

:deep(.el-tabs__nav-wrap) {
  width: 100%;
}

:deep(.el-tabs__active-bar) {
  height: 2px;
  margin-bottom: 12px;
  background-color: #2E64F3;
}

:deep(.el-tabs .el-tabs__active-bar .is-top) {
  width: 90px;
}

:deep(.el-tabs .el-tabs__item) {
  width: 120px;
  text-align: center;
  height: 20px;
  font-size: 20px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  
  line-height: 20px;

  padding: 20px 0 46px 0;
}

:deep(.el-tabs .el-tabs__item.is-active) {
  color: #2E64F3;
}
</style>
